










































































































































import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';

import exceljs from 'exceljs';
import AxAPI from '@/api';
import moment from 'moment';
import { History } from '@/interfaces';

type Group = I.AxZone;

type PageInfo = I.MealSettingPageInfo;

type HistoryList = {};

type DataItem = U.DataItem<HistoryList, State>;
type DataStore = U.DataStore<HistoryList>;

type UpdateItemParam = I.PacketMealTimeUpdate;

const DataStore = U.DataStore;

class State {
  fromDatetime: string;
  fromDatetimeMenu: boolean;
  toDatetime: string;
  toDatetimeMenu: boolean;

  empno: string;
  name: string;
  cardName: string;
  cardNo: string;
  userInfo: string;

  constructor() {
    this.fromDatetime = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
    this.fromDatetimeMenu = false;
    this.toDatetime = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
    this.toDatetimeMenu = false;

    this.empno = '' as never;
    this.name = '' as never;
    this.cardName = '' as never;
    this.cardNo = '' as never;
    this.userInfo = '' as never;
  }
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  pageInfo!: PageInfo;
  dataItem!: DataItem;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  callback!: Function;

  async getPageInfo() {
    const result = await this.API.call.meal.configGet();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async searchHistory(packet: I.PacketTempStaffHistorySearch) {
    this.setLoading(true);
    const result = await this.API.call.temp.tempStaffHistory(packet);
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '임시증 관리 (임직원) 히스토리',
      store: new DataStore<HistoryList>({
        headers: {
          tempName: '카드명',
          tempCardNo: '카드번호',
          name: '이름',
          empNo: '사원번호',
          userInfo: '사용자 정보',
          issueDateTime: '발급시간',
          returnDateTime: '반납시간'
        }
      }),
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[0];
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;

  on = true;
  width = 1020;
  height = 780;

  pageInfo = {} as I.MealSettingPageInfo;

  @Prop({ default: () => new I.DataParam() })
  param!: I.DataParam;

  @Prop({ type: Function, default: () => {} })
  callback!: Function;

  @Watch('on')
  onSwitchChanged() {
    this.$emit('changed', this.on);
  }
}

@Component
class ExcelExportHandler extends Mixins(AxPage) {
  dataItem!: DataItem;

  async onExportExcelConfirm(prefix: string) {
    console.log('excel', this.dataItem.description.length);
    if (!this.dataItem.description.length) {
      await this.showErrorModal('오류', '조회 후 엑셀 다운로드가 가능합니다');
      return;
    }

    const result = await this.showConfirmModal(
      '확인',
      '검색한 데이터들을 엑셀로 내보냅니다<br />계속하시겠습니까?',
      ['네', '아니오']
    );
    if (result === 0) {
      this.setLoading(true);
      setTimeout(() => this.onExportExcel(prefix), 500);
    }
  }

  async onExportExcel(prefix: string) {
    try {
      const colNames = (n: number) => {
        const ordA = 'A'.charCodeAt(0);
        const ordZ = 'Z'.charCodeAt(0);
        const len = ordZ - ordA + 1;

        let s = '';
        while (n >= 0) {
          s = String.fromCharCode((n % len) + ordA) + s;
          n = Math.floor(n / len) - 1;
        }
        return s;
      };

      moment.locale('ko');
      const momentTime = moment(Date.now());
      const outputPrefix = `${prefix.replace(/\s/g, '_')}_${this.dataItem.name.replace(
        /\s/g,
        ''
      )}_`;

      const workbook = new exceljs.Workbook();
      const worksheet = workbook.addWorksheet('sheet', { properties: { defaultColWidth: 10 } });
      const headers = this.dataItem.store.getHeaders();

      // 엑셀 내보내기시 수작업으로 순번 필드를 만드므로 순번 필드를 삭제시킨다
      const headerEntries = Object.entries(headers).filter(x => x[0] !== 'num');
      const headerKeys = headerEntries.map(x => x[0]);
      const headerValues = headerEntries.map(x => x[1]);

      if (!headers) {
        await this.showErrorModal('확인', '올바르지 않은 테이블 구조입니다');
        return;
      }

      // 헤더 작성 (식수 조회 [사원별] 등등..)
      const headerSize = headerKeys.length;
      worksheet.mergeCells(`A1:${colNames(headerSize)}1`);
      worksheet.getCell('A1').value = `${prefix} [${this.dataItem.name}]`;
      worksheet.getCell('A1').font = { family: 4, size: 18, bold: true };
      worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell('A1').border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };

      let row = 2;

      // 구역이나 회사 등등은 검색시 만들어둔 description table을 참고한다
      // 검색 당시와 현재 조건이 다를 수 있으므로 이를 보완한 방법
      this.dataItem.description.forEach(x => {
        worksheet.mergeCells(`A${row}:${colNames(headerSize)}${row}`);
        worksheet.getCell(`A${row++}`).value = x;
      });

      // 생성 시간은 검색 시간과 무관하게 현재 시간을 기준으로 삼는다

      worksheet.mergeCells(`A${row}:${colNames(headerSize)}${row}`);
      worksheet.getCell(`A${row++}`).value = `생성시간 : ${momentTime.format('YYYY-MM-DD LT')}`;

      worksheet.insertRow(
        row,
        [
          'No.',
          ...headerValues.map(x => {
            if (typeof x === 'string') return x;
            else {
              const y = (x as unknown) as { [key: string]: unknown };
              if (y.text) {
                return y.text;
              } else {
                return y;
              }
            }
          })
        ],
        'i'
      );
      const headerRow = row++;
      // 테두리 넣기
      worksheet.getRow(headerRow).eachCell(cell => {
        cell.style = {};
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });

      // 아이템 필터. Header에 들어간 item만 뽑는다
      this.dataItem.store.getItems().forEach((x, idx) => {
        const arr: unknown[] = [idx + 1];
        headerKeys.forEach(y => {
          if (y === 'eventTime') {
            arr.push(this.formatTime(((x as unknown) as { [key: string]: string })[y]));
          } else {
            arr.push(((x as unknown) as { [key: string]: unknown })[y]);
          }
        });
        worksheet.insertRow(row++, arr, 'i');
      });

      // 헤더 라인에 음영 넣기
      worksheet.getRow(headerRow).eachCell(cell => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFBFBFBF' },
          bgColor: { argb: 'FFFFFF00' }
        };

        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });

      // 엑셀 파일을 저장한다
      const xls64 = await workbook.xlsx.writeBuffer();
      const a = document.createElement('a');
      const data = new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const url = URL.createObjectURL(data);
      a.href = url;
      a.download = outputPrefix + momentTime.format('YYYY_MM_DD_HH_mm_ss') + '.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout(function() {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    } catch (e) {
      await this.showErrorModal('엑셀 내보내기 오류', e.message);
    }
    this.setLoading(false);
  }
}

const Handlers = Mixins(Mixins(ApiHandler, DataItemHandler, ExcelExportHandler));

@Component
export default class AxTempStaffHistoryDialog extends Mixins(BaseData, Handlers) {
  async prepare() {
    const pageInfo = await this.getPageInfo();
    if (pageInfo) {
      this.pageInfo = pageInfo;
    }
  }

  staffList: I.TempStaffHistoryList[] = [];
  async onDialogRowClicked(item: I.SensorExtData) {
    console.log(item);
  }

  async onSearchClicked() {
    const result = await this.onTempStaffHistory();
    if (!result) return;

    this.dataItem.store.setItems(result);
    this.dataItem.description = [];
    this.dataItem.description.push(
      `조회기간 : ${this.dataItem.state.fromDatetime} ~ ${this.dataItem.state.toDatetime}`
    );
  }

  makeTemphistoryPacket(): I.PacketTempStaffHistorySearch {
    return {
      fromDatetime: this.dataItem.state.fromDatetime,
      toDatetime: this.dataItem.state.toDatetime,
      name: this.dataItem.state.name,
      empno: this.dataItem.state.empno,
      cardName: this.dataItem.state.cardName,
      cardNo: this.dataItem.state.cardNo,
      userInfo: this.dataItem.state.userInfo
    };
  }

  async onTempStaffHistory() {
    this.setLoading(true);
    const result = await this.searchHistory(this.makeTemphistoryPacket());
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      if (result) {
        this.dataItem.store.setItems(result);
        this.dataItem.description = [];
        this.dataItem.description.push(
          `조회기간 : ${this.dataItem.state.fromDatetime}  ~ ${this.dataItem.state.toDatetime}`
        );
      }
    }
  }
}
